// extracted by mini-css-extract-plugin
module.exports = {"cases":"APXXlwdE","slider-item":"UBRP6PsL"};